// Hẹn gửi (docs/KE_HOACH_HEN_GIO_GUI_DON.md): giờ hẹn hiển thị + ô chọn ngày giờ (datetime-local, giờ máy).

/** Máy chủ nhận giờ hẹn sau bây giờ ít nhất 5 phút (apps/api/src/lib/scheduledSend.ts MIN_LEAD_MS) */
export const SEND_AT_MIN_LEAD_MS = 5 * 60_000

const pad = (n: number) => String(n).padStart(2, "0")

/** "08:00 30/10" — khác năm nay thì thêm năm: "08:00 30/10/2027" */
export function sendAtLabel(value: string | Date | null | undefined): string {
  if (!value) return ""
  const d = typeof value === "string" ? new Date(value) : value
  if (Number.isNaN(d.getTime())) return ""
  const day = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}${d.getFullYear() !== new Date().getFullYear() ? `/${d.getFullYear()}` : ""}`
  return `${pad(d.getHours())}:${pad(d.getMinutes())} ${day}`
}

/** Date → giá trị ô datetime-local ("YYYY-MM-DDTHH:mm", giờ máy) */
export function toLocalInput(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** Giá trị ô datetime-local → Date (giờ máy); rỗng / sai → null */
export function fromLocalInput(v: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(v)
  if (!m) return null
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]))
  return Number.isNaN(d.getTime()) ? null : d
}

/** Giá trị đầu khi bật Hẹn gửi: 08:00 sáng mai */
export function defaultSendAt(now = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 8, 0)
}

/** Lỗi giờ hẹn (null = được) — cùng điều kiện với máy chủ */
export function sendAtError(d: Date | null, now = new Date()): string | null {
  if (!d) return "Chọn giờ hẹn gửi"
  if (d.getTime() < now.getTime() + SEND_AT_MIN_LEAD_MS) return "Giờ hẹn gửi phải sau bây giờ ít nhất 5 phút"
  return null
}
